import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { isUserInfoSupported } from 'app/state/user-session/user-session.utils';

import { ApiVersion, Credentials } from '../../../models';
import { TerminalClient } from '../../../services';
import { AuthResponse } from '../model/auth-response.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private terminalClient = inject(TerminalClient);

    authenticate({
        credentials,
        identifier,
        apiVersion,
    }: {
        credentials: Credentials;
        identifier: string;
        apiVersion: ApiVersion;
    }): Observable<AuthResponse> {
        if (isUserInfoSupported(apiVersion)) {
            return this.terminalClient
                .getUserInfo({ credentials, identifier, apiVersion })
                .pipe(map((userInfo) => ({ isAuthenticated: !!userInfo, userInfo })));
        }

        return this.terminalClient
            .authenticate({ credentials, identifier, apiVersion })
            .pipe(map((isAuthenticated): AuthResponse => ({ isAuthenticated, userInfo: undefined })));
    }
}
